import type { PaletteType } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import createTypography from '@material-ui/core/styles/createTypography';

import * as palettes from './palette';

export const createTheme = ({ type }: { type: PaletteType }) => {
  const palette = palettes[type];
  const typography = createTypography(palette, {
    fontFamily: "'Noto Sans', sans-serif;",
    fontWeightMedium: 400,
    button: { textTransform: 'none' },
    h1: {
      fontFamily: '"Vanguard CF", sans-serif',
      fontWeight: 700,
      fontSize: 72,
    },
    h2: {
      fontFamily: '"Vanguard CF", sans-serif',
      fontWeight: 'bold',
      fontSize: 32,
      color: 'gold',
    },
    subtitle1: {
      fontFamily: '"Vanguard CF", sans-serif',
      fontWeight: 500,
      fontSize: 16,
      color: '#8595C0',
    },
    body1: {
      opacity: 1,
    },
    body2: {
      opacity: 0.7,
    },
  });
  const breakpoints = createBreakpoints({
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  });
  return createMuiTheme({
    typography,
    palette,
    breakpoints,
  });
};
